import { initExploreOnScroll } from "../../helpers/helpers.js";

export default class OnScrollAnimations {  
  constructor() {
    /**
     * init onScroll animations
     * N.B. !!!
     * a GSap non piace il lazyload su immagini
     * se c'�, bisogna rimuoverlo!
     * */
    gsap.registerPlugin(ScrollTrigger);
  }

  init() {
    this.initCardsAlternateOnScroll();
    this.initExperiencesOnScroll();
    this.initSustOnScroll();
    this.initCardsParallaxOnScroll();
    this.initGalleriesInlineOnScroll();
    this.initCardsXlOnScroll();
    this.initBgSqCardsOnScroll();
    this.initSectionVisitsOnScroll();
    initExploreOnScroll(document.querySelectorAll(".js-section-explore"));
  }

  initSectionVisitsOnScroll() {
    const figures = document.querySelectorAll(".js-section-visit figure");
    figures?.forEach(figure => {
      gsap.from(figure, {
        scrollTrigger: {
          trigger: figure?.closest(".js-section-visit"),
          start: "top center",
          end: () => " bottom",
          //markers: true
        },
        opacity: 0,
        y: "25%",
        duration: 1
      });
    });
  }

  initBgSqCardsOnScroll() {
    const blocks = document.querySelectorAll(".js-bg-sq-cards");
    blocks?.forEach((block, i) => {
      const first = block.querySelector(".section-header");
      const last = block.querySelector(".js-sq-cards");
      last?.style.setProperty("opacity", 0);

      gsap.from(first, {
        scrollTrigger: {
          trigger: block,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          // markers: true
        },
        opacity: 0,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          // console.log("init", i);
          last?.style.removeProperty("opacity");

          gsap.from(last, {
            opacity: 0,
            y: "100%",
            duration: 1,
            delay: .5
          });
        }
      });
    });
  }

  initCardsXlOnScroll() {
    const cards = document.querySelectorAll(".js-card-xl");
    //console.log(cards.length)
    cards?.forEach((card, i) => {
      const first = card.querySelector("figure");
      const last = card.querySelector(".card-body");
      last?.style.setProperty("opacity", 0);

      gsap.from(first, {
        scrollTrigger: {
          trigger: card,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          // markers: true
        },
        opacity: 0,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          // console.log("init", i);
          last?.style.removeProperty("opacity");

          gsap.from(last, {
            opacity: 0,
            y: "100%",
            duration: 1,
            delay: .25
          });
        }
      });
    });
  }

  initGalleriesInlineOnScroll() {
    const galleries = document.querySelectorAll(".js-gallery-inline");
    galleries?.forEach(gallery => {
      const left = gallery.querySelector(".figure-left");
      const right = gallery.querySelector(".figure-right");
      right?.style.setProperty("opacity", 0);

      gsap.from(left, {
        scrollTrigger: {
          trigger: gallery,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          // start: "center bottom",
          // end: () => " bottom",
          // markers: true
        },
        opacity: 0,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          right?.style.removeProperty("opacity");

          gsap.from(right, {
            opacity: 0,
            y: "100%",
            duration: 1,
            delay: .25
          });
        }
      });
    });
  }

  initCardsParallaxOnScroll() {
    const cards = document.querySelectorAll(".js-card-parallax");
    cards?.forEach(card => {
      const figure = card.querySelector(".js-figure-parallax");
      const body = card.querySelector(".js-body-parallax");

      gsap.from(figure, {
        scrollTrigger: {
          trigger: card,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          //markers: true
        },
        opacity: 0,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          figure.classList.remove("not-ready");

          gsap.from(body, {
            opacity: 0,
            y: "100%",
            duration: 1,
            delay: .25
          });
        }
      });
    });
  }

  initSustOnScroll() {
    const sustBlocks = document.querySelectorAll(".js-section-sustainability");
    sustBlocks?.forEach(block => {
      const figure = block.querySelector("figure");

      gsap.from(figure, {
        scrollTrigger: {
          trigger: block,
          start: () => {
            if (!window.matchMedia("(hover: hover)").matches) {
              return `${-Math.round(window.innerHeight / 3)}px center`;

            } else {
              return "top center";
            }
          },
          end: () => {
            return "top center";
          },
          // markers: true
        },
        opacity: 0,
        y: "100%",
        duration: 1,
      });
    });
  }

  initExperiencesOnScroll() {
    const expBlocks = document.querySelectorAll(".js-section-experiences");
    expBlocks?.forEach(exp => {
      const header = exp.querySelector(".section-header");
      const experiences = exp.querySelectorAll(".experience");

      gsap.from(header, {
        scrollTrigger: {
          trigger: exp,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          //markers: true
        },
        opacity: 1,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          let delay = 1;
          experiences?.forEach((exp, i) => {
            exp.classList.remove("not-ready");

            gsap.from(exp, {
              opacity: 0,
              y: "100%",
              duration: 1,
              delay: (delay + i) / 2
            });

            delay = delay / 2;
          });
        }
      });
    });
  }

  initCardsAlternateOnScroll() {
    const figures = document.querySelectorAll(".js-section-cards-alternate figure");
    figures?.forEach(figure => {
      gsap.from(figure, {
        scrollTrigger: {
          trigger: figure?.closest("article"),
          start: "center bottom",
          end: () => " bottom",
          //markers: true
        },
        opacity: 0,
        y: "25%",
        duration: 1
      });
    });
  }
}